import isNumber from 'lodash/isNumber';
import { DateTime } from 'luxon';

export default {
  methods: {

    /**
     * Regarde si le checkbox du cours permet l'inscription ou non.
     *
     * @param _class
     * @returns {boolean}
     * @private
     */
    _classAcceptRegistrations(_class) {
      return _class.acceptRegistrations;
    },

    /**
     * Regarde si le cours est plein.
     *
     * @param _class
     * @returns {boolean}
     * @private
     */
    _classIsFull(_class) {
      if (!isNumber(_class.maximumInscriptions) || !isNumber(_class.registrationNumber)) {
        return false;
      }
      return _class.registrationNumber >= _class.maximumInscriptions;
    },

    /**
     * Regarde si la période d'inscription à un cours est maintenant.
     *
     * @param _class
     * @returns {boolean}
     * @private
     */
    _classRegistrationPeriodIsNow(_class) {
      const now = DateTime.local();

      // If no limit, then allow registration
      if (!_class.inscriptionLimit) {
        return true;
      }
      const inscriptionLimit = DateTime.fromISO(_class.inscriptionLimit).setZone('America/New_York');

      // Check if we enforce a start date for the registrations
      if (_class.allowInscriptionsAfter) {
        const allowAfter = DateTime.fromISO(_class.allowInscriptionsAfter).setZone('America/New_York');
        return now < inscriptionLimit && now >= allowAfter;
      }
      else {
        return now < inscriptionLimit;
      }
    },

    /**
     * Regarde si le cours accepte les inscriptions en ce moment.
     * @param _class
     * @return {boolean}
     */
    isAllowingRegistrations(_class) {
      if (!this._classAcceptRegistrations(_class) || this._classIsFull(_class)) {
        return false;
      }
      return this._classRegistrationPeriodIsNow(_class);
    }
  }
};
